import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Byte-budget LRU for decompressed artifact bytes (screenshots, logs).
 * run.yaml / result.yaml bytes are never cached here — their parsed form in
 * the store is the cache. Oversized values bypass the cache (read-through)
 * rather than evicting everything else.
 */
export var ByteBudgetLru = /*#__PURE__*/function () {
  function ByteBudgetLru(maxBytes) {
    _classCallCheck(this, ByteBudgetLru);
    _defineProperty(this, "map", new Map());
    _defineProperty(this, "total", 0);
    this.maxBytes = maxBytes;
  }
  return _createClass(ByteBudgetLru, [{
    key: "bytes",
    get: function get() {
      return this.total;
    }
  }, {
    key: "get",
    value: function get(key) {
      var v = this.map.get(key);
      if (v !== undefined) {
        // refresh recency
        this.map["delete"](key);
        this.map.set(key, v);
      }
      return v;
    }
  }, {
    key: "set",
    value: function set(key, bytes) {
      if (bytes.byteLength > this.maxBytes) return; // bypass, don't thrash
      var existing = this.map.get(key);
      if (existing) {
        this.total -= existing.byteLength;
        this.map["delete"](key);
      }
      this.map.set(key, bytes);
      this.total += bytes.byteLength;
      this.evict();
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var v = this.map.get(key);
      if (v) {
        this.total -= v.byteLength;
        this.map["delete"](key);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
      this.total = 0;
    }
  }, {
    key: "evict",
    value: function evict() {
      var _iterator = _createForOfIteratorHelper(this.map),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            v = _step$value[1];
          if (this.total <= this.maxBytes) return;
          this.map["delete"](key);
          this.total -= v.byteLength;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
}();